import { publicLayout } from '../_common/layout.public';
import { ConfigSection } from '../../components-fabric';
import LoginScreen from './views/LoginScreen';

/**
 * Configuration Section: authSection
 *
 * This configuration section defines the authentication-related screens for the application. It includes login and logout screens.
 *
 * Properties:
 * @property {string} id - The unique identifier for this section.
 * @property {Object} layout - The layout component to use for the section, in this case, a public layout.
 * @property {boolean} protected - Indicates if the section requires authentication to access (false for this section).
 * @property {string} tmp - The template type to use for this section, set to 'basic'.
 * @property {string} path - The base path for this section's routes.
 * @property {Array} screens - An array of screen configurations included in this section.
 */
export const authSection: ConfigSection = {
  id: 'auth',
  layout: publicLayout,
  protected: false,
  tmp: 'basic',
  path: '/auth',
  screens: [
    {
      id: 'login',
      Component: LoginScreen,
      roles: ['STUDENT', 'LECTURER', 'STUDY_DIRECTOR'],
    },
  ],
} as any;
